import React, {Component} from "react";

class Statistic extends Component {
	render() {
		return <div></div>;
		return (
			<iframe
				src="https://maxline.by/stats.php"
				width="100%"
				height="600px"
				frameborder="0"></iframe>
		);
	}
}

export default Statistic;


// WEBPACK FOOTER //
// ./src/app/pages/Statistic/Statistic.js